<template>
  <div v-if="loading">
    <Loader />
  </div>
  <div v-if="!loading" class="card shadow-sm">
    <form id="formItems" class="needs-validation" novalidate>
      <div class="card-header">
        <h3 class="card-title" style="font-size: 20px; font-weight: bold">
          {{
            $route.query.status === "1"
              ? "ข้อมูลสินค้าเข้าระบบ"
              : "แก้ไขสินค้าเข้าระบบ"
          }}
        </h3>
      </div>
      <!-- form -->
      <div class="card-body">
        <!-- -->
        <div class="row d-flex justify-content-center">
          <div class="col-sm-6">
            <label for="selectMainProduct" class="form-label">เลขที่</label>
            <input v-model="docNumber" disabled class="form-control mb-4" />
          </div>

          <div class="col-sm-6">
            <label for="selectMainProduct" class="form-label"
              >วันที่เอกสาร</label
            >
            <!-- <input
              v-model="form.document_date"
              type="date"
              disabled
              class="form-control mb-4"
            /> -->
            <a-date-picker
              class="form-control ant-date"
              disabled
              v-model:value="date"
              format="DD/MM/YYYY"
            />
          </div>
        </div>

        <div class="row d-flex justify-content-center mb-4">
          <label for="selectMainProduct" class="form-label col-sm-12"
            >ผู้ขอตัดสต๊อก</label
          >
          <div class="col-sm-12">
            <input v-model="userStock" disabled class="form-control" />
          </div>
        </div>

        <div class="row text-end">
          <div class="col-sm-12">
            <button
              type="button"
              class="btn btn-sm btn-light-primary"
              style="font-size: 14px; font-weight: bold"
              :disabled="form.status === '1' ? true : false"
              @click="addItem"
            >
              เพิ่ม
            </button>
            <AddItem
              :dialogAddItem="dialogAddItem"
              :dataEditItem="dataEditItem"
              @submitEditItem="submitEditItem"
              @submitAddItem="submitAddItem"
              @closeDialogAddItem="closeDialogAddItem"
            />
          </div>
        </div>

        <div class="table-responsive" style="padding-top: 3px">
          <table
            class="table table-hover table-rounded table-striped border gy-7 gs-7"
          >
            <thead>
              <tr
                style="width: 100%"
                class="fw-bold fs-5 text-gray-800 border-bottom-2 border-gray-200 mw-200px"
              >
                <th>#</th>
                <th>Item code</th>
                <th>Item name</th>
                <th>PO_QTY</th>
                <th>Price</th>
                <th>Discount</th>
                <th>Vat</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in form.products" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.product_code }}</td>
                <td>{{ item.product_name }}</td>
                <td>{{ item.item_amt }}</td>
                <td>{{ item.product_cost_price }}</td>
                <td>{{ item.item_discount ? item.item_discount : 0 }}</td>
                <td>
                  {{
                    ((parseInt(
                      item.product_cost_price ? item.product_cost_price : 0
                    ) -
                      parseInt(item.item_discount ? item.item_discount : 0)) *
                      parseInt(item.item_amt ? item.item_amt : 0) *
                      7) /
                    100
                  }}
                </td>
                <td>
                  {{
                    ((parseInt(
                      item.product_cost_price ? item.product_cost_price : 0
                    ) -
                      parseInt(item.item_discount ? item.item_discount : 0)) *
                      parseInt(item.item_amt ? item.item_amt : 0) *
                      7) /
                      100 +
                    (parseInt(
                      item.product_cost_price ? item.product_cost_price : 0
                    ) -
                      parseInt(item.item_discount ? item.item_discount : 0)) *
                      parseInt(item.item_amt ? item.item_amt : 0)
                  }}
                </td>
                <td>
                  <div class="row">
                    <div class="col-sm-6 d-flex justify-content-md-end">
                      <button
                        type="button"
                        class="btn btn-link btn-color-muted btn-active-color-success p-0"
                        :disabled="form.status === '1' ? true : false"
                        @click="goToEditItem(index)"
                      >
                        <i class="bi bi-pencil-square"></i>
                      </button>
                    </div>
                    <div class="col-sm-6">
                      <button
                        type="button"
                        class="btn btn-link btn-color-muted btn-active-color-danger p-0"
                        :disabled="form.status === '1' ? true : false"
                        @click="goToDeleteItem(index, item)"
                      >
                        <i class="bi bi-trash3-fill"></i>
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="row d-flex justify-content-center mt-4">
          <div class="col-sm-8">
            <label for="selectMainProduct" class="form-label">หมายเหตุ</label>
            <input
              :disabled="form.status === '1' ? true : false"
              v-model="form.note"
              class="form-control mb-4"
            />
            <label for="selectMainProduct" class="form-label">โอนจาก</label>
            <select
              :disabled="form.status === '1' ? true : false"
              class="form-select mb-4"
              v-model="form.warehouseId"
              id="validationTooltip01"
              required
            >
              <option v-for="item in warehouses" :key="item" :value="item.id">
                {{ item.warehouse_code }} |
                {{ item.warehouse_name }}
              </option>
            </select>
          </div>

          <div class="col-sm-4">
            <label for="selectMainProduct" class="form-label"
              >มูลค่ารวม(ก่อนVAT)</label
            >
            <input
              v-model="form.total_price_before_vat"
              disabled
              class="form-control mb-4"
            />

            <!-- <label for="selectMainProduct" class="form-label">ส่วนลดรวม</label>
            <input v-model="form.discount" disabled class="form-control mb-4" />

            <label for="selectMainProduct" class="form-label">VAT</label>
            <input
              v-model="form.total_price_include_vat"
              disabled
              class="form-control mb-4"
            />

            <label for="selectMainProduct" class="form-label"
              >มูลค่าสุทธิ</label
            >
            <input
              v-model="form.total_price_summary"
              disabled
              class="form-control"
            /> -->
          </div>
        </div>
      </div>

      <hr class="pt-0 mt-0" style="color: LightGrey" />

      <footer class="m-6">
        <div class="card-toolbar row justify-content-center">
          <div class="col-sm-12">
            <button
              v-if="form.status === '1'"
              type="submit"
              class="btn btn-sm btn-secondary"
              style="font-size: 14px; font-weight: bold"
              @click="goBack()"
            >
              กลับ
            </button>

            <button
              v-if="form.status === '0'"
              type="submit"
              class="btn btn-sm btn-light btn-primary ms-3 me-2"
              style="font-size: 14px; font-weight: bold"
              @click="submit"
              :disabled="loadingUpdate"
            >
              <div
                v-if="loadingUpdate"
                class="spinner-grow spinner-grow-sm text-light"
                role="status"
              ></div>
              บันทึก
            </button>

            <button
              v-if="form.status === '0'"
              type="button"
              class="btn btn-sm btn-light"
              style="font-size: 14px; font-weight: bold"
              @click="cancel"
            >
              ยกเลิก
            </button>
          </div>
        </div>
      </footer>
    </form>
  </div>
</template>

<script>
import AddItem from "./components/dialogAddItem.vue";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Loader from "../../components/loaderUpdate.vue";

import whApi from "@/api/warehouse/";
import userApi from "@/api/user/";
import moment from "moment";

import { Decode, Encode } from "@/services";

export default {
  components: {
    AddItem,
  },
  setup() {
    document.title = "CHOMTHANA | แก้ไขใบตัดสต๊อก";
  },
  data: () => ({
    docNumber: "",
    userStock: "",

    searchProduct: "",

    dialogAddItem: false,
    dialogSalesman: false,

    loading: false,
    isSubmit: false,
    loadingUpdate: false,

    dataEditItem: {},
    indexEditItem: 0,
    warehouses: [],
    users: [],

    date: "",
    form: {
      cut_off_no: "",
      document_date: "",
      userId: "",
      warehouseId: "",
      note: "",
      products: [],
      expired_product: "0",
      status: "0",

      total_price_before_vat: 0,
      discount: 0,
      total_price_include_vat: 0,
      total_price_summary: 0,
    },
    ccsSelect: `background-size: 16px 12px;background-position: right 1rem center;background-repeat: no-repeat;background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%237E8299' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e")`,
  }),

  async created() {
    await this.getWarehouse();
    await this.getAllUser();
    await this.getOne();
  },

  methods: {
    async getOne() {
      this.loading = true;
      let getOneResponse = {};
      try {
        getOneResponse = await whApi.cutOffStock.getOne(this.$route.query.id);
      } catch (error) {
        console.log(error);
      }
      if (getOneResponse.response_status === "SUCCESS") {
        this.docNumber = getOneResponse.data.cut_off_no;
        this.form = {
          ...this.form,
          ...getOneResponse.data,
          selectMainWarehouse: getOneResponse.data.warehouse_main ? "1" : "2",
          // products: getOneResponse.data.cutOffStockItems,
        };
        this.setUser();
        this.setFormProducts();
        this.setDate();
        this.loading = false;
      }
    },
    async getAllUser() {
      // this.form.userId = Decode.decode(localStorage.getItem("boss"));
      let responseData = [];

      try {
        responseData = await userApi.user.getAll();
      } catch (error) {
        console.log(error);
      }
      if (responseData.response_status === "SUCCESS") {
        this.users = responseData.data;
        // const users = responseData.data;
        // const findUser = users.find(
        //   (data) => data.id === parseInt(this.form.userId)
        // );

        // if (findUser) {
        //   this.userStock = `${findUser.firstName} ${findUser.lastName}`;
        // }
      }
    },
    async getWarehouse() {
      let responseData = [];
      try {
        responseData = await whApi.warehouse.getAll();
      } catch (error) {
        console.log(error);
      }
      if (responseData.response_status === "SUCCESS") {
        this.warehouses = responseData.data;
        this.form.warehouseId = this.warehouses[0].id;
      }
    },

    setUser() {
      this.userStock = `${this.form.user.firstName} ${this.form.user.lastName}`;
    },

    setFormProducts() {
      this.form.cutOffStockItems.forEach((element) => {
        this.form.products.push({
          item_amt: element.item_amt,
          item_price: element.item_price,
          cusOffStockItemId: element.id,
          companyId: element.companyId,
          ...element.product,
        });
      });
      this.totalBeforeVat();
    },

    setDate() {
      this.date = moment(new Date(this.form.document_date));
    },

    setDateBeforeSubmit() {
      this.form.document_date = moment(this.form.document_date)
        .add(-543, "year")
        .format("YYYY-MM-DD");
    },
    async submit() {
      let updateResponse = [];

      await this.validateForm();
      await this.checkFormIsEmpty();
      this.isSubmit = true;

      if (this.isValid) {
        this.loadingUpdate = true;

        this.addWarehouseToItems();
        this.setDateBeforeSubmit();

        this.form = {
          ...this.form,
          companyId: parseInt(localStorage.getItem("companyId")),
        };

        updateResponse = await whApi.cutOffStock.update(
          this.$route.query.id,
          this.form
        );
        if (updateResponse.response_status === "SUCCESS") {
          Swal.fire({
            icon: "success",
            title: "แก้ไขสำเร็จ",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            this.$router.push({
              path: "/warehouse/WH6-3",
              query: {},
            });
          });
          this.loadingUpdate = false;
        } else {
          Swal.fire({
            icon: "error",
            title: "แก้ไขไม่สำเร็จ !",
            showConfirmButton: false,
            timer: 1500,
          });
          this.loadingUpdate = false;
        }
      }
    },

    checkFormIsEmpty() {
      !this.form.warehouseId ? (this.isValid = false) : (this.isValid = true);
    },

    validateForm() {
      let forms = document.querySelectorAll(".needs-validation");
      Array.prototype.slice.call(forms).forEach(function (form) {
        form.addEventListener(
          "submit",
          function (event) {
            event.preventDefault();
            if (!form.checkValidity()) {
              event.stopPropagation();
            }
            form.classList.add("was-validated");
          },
          false
        );
      });
    },
    addWarehouseToItems() {
      let newProducts = [];
      this.form.products.forEach((element) => {
        newProducts.push({
          ...element,
          warehouseId: this.form.warehouseId,
        });
      });
      this.form.products = newProducts;
    },
    cancel() {
      // this.addWarehouseToItems();

      this.$router.go(-1);
    },
    goBack() {
      // this.$router.go(-1);
      this.$router.push({
        path: "/warehouse/WH6-3",
        query: {},
      });
    },

    // product
    addItem() {
      this.dialogAddItem = true;
      this.dataEditItem = {};
    },
    submitAddItem(item) {
      this.form.products.push(item);
      this.totalBeforeVat();
    },
    submitEditItem(item) {
      this.form.products.splice(this.indexEditItem, 1, item);
    },
    closeDialogAddItem() {
      this.dialogAddItem = false;
    },
    goToEditItem(index) {
      this.dataEditItem = this.form.products[index];
      this.indexEditItem = index;
      this.dialogAddItem = true;
    },
    async goToDeleteItem(index, item) {
      console.log({ item });
      Swal.fire({
        icon: "question",
        text: `ต้องการลบรายการที่ ${index + 1} สินค้าใช่หรือไม่ ?`,
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          whApi.cutOffStock.deleteItem(item.cusOffStockItemId);

          if (index > 0) {
            this.form.products.splice(index, 1);
          } else {
            this.form.products.shift();
          }
          this.totalBeforeVat();
        }
      });
    },
    //total
    totalBeforeVat() {
      let total = 0;
      let vat = 0;

      this.form.products.forEach((element) => {
        if (element.product_cost_price) {
          total +=
            parseInt(element.product_cost_price) * parseInt(element.item_amt);
          vat +=
            (parseInt(element.product_cost_price) *
              parseInt(element.item_amt) *
              7) /
            100;
        }
      });

      this.form.total_price_before_vat = parseInt(total);

      this.form.total_price_include_vat = parseInt(total) + vat;

      this.form.total_price_summary =
        this.form.total_price_include_vat +
        parseInt(this.form.delivery_price ? this.form.delivery_price : 0) -
        parseInt(this.form.discount ? this.form.discount : 0);

      this.form.final_price = this.form.total_price_summary;
    },
  },
};
</script>
<style scoped src="@/assets/custom-outside.css"></style>
